module.exports = __webpack_public_path__ + "static/media/2.a8fc9c30.JPG";